import { SolanaWithoutSignerBaseCommand } from '../../../../solana';
import { chalkString } from '../../../../utils';

import { BN, type web3 } from '@coral-xyz/anchor';
import {
  getAccount,
  getAssociatedTokenAddress,
  getMint,
} from '@solana/spl-token';
import { State, StateData } from '@switchboard-xyz/on-demand';
import chalk from 'chalk';

export default class StatePrint extends SolanaWithoutSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'print the state account';

  static flags = {
    ...SolanaWithoutSignerBaseCommand.flags,
  };

  static args = {};

  async run() {
    // const { args, flags } = await this.parse(
    //   this.constructor as typeof StatePrint
    // );

    const program = await this.program;
    const stateAccount = new State(program);

    const state = await stateAccount.loadData();

    console.log(await this.prettyPrintState(state, stateAccount.pubkey));
  }

  async prettyPrintState(
    state: StateData,
    publicKey: web3.PublicKey,
    SPACING = 24
  ): Promise<string> {
    const output: string[] = [];

    output.push(
      chalk.underline(chalkString('## State', publicKey.toString(), SPACING))
    );

    // output.push(chalkString('bump', state.bump.toString(), SPACING));
    output.push(chalkString('authority', state.authority.toString(), SPACING));
    output.push(
      chalkString('guardianQueue', state.guardianQueue.toString(), SPACING)
    );
    output.push(
      chalkString('switchMint', state.switchMint.toString(), SPACING)
    );
    try {
      const mintInfo = await getMint(this.connection, state.switchMint);
      const ataAddress = await getAssociatedTokenAddress(
        state.switchMint,
        publicKey,
        true
      );
      const ataAccount = await getAccount(this.connection, ataAddress);

      const decimals = mintInfo.decimals;
      const subsidyAmountFormatted = formatBNToDecimal(
        new BN(state.subsidyAmount),
        decimals
      );
      output.push(
        chalkString('subsidyAmount', subsidyAmountFormatted, SPACING)
      );
      const vaultAmountFormatted = formatBNToDecimal(
        ataAccount.amount,
        decimals
      );
      output.push(chalkString('vaultAmount', vaultAmountFormatted, SPACING));
    } catch {} // eslint-disable-line no-empty

    // _ebuf* fields are reserved and might not need to be displayed.
    // If needed, they can be added similar to the other fields.

    return output.join('\n');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to print queue');
  }
}

export function formatBNToDecimal(
  amount: BN | bigint | string,
  decimals: number
): string {
  const bnAmount = new BN(amount.toString());
  const divisor = new BN(10).pow(new BN(decimals)); // 10^decimals
  const wholePart = bnAmount.div(divisor).toString(); // Integer part
  const fractionalPart = bnAmount
    .mod(divisor)
    .toString()
    .padStart(decimals, '0'); // Fraction

  return `${wholePart}.${fractionalPart}`;
}
